import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
import axiosInstance from "../../../../../../Utils/axios";
let cancelToken;

const saleReturnBranchURL = `api/v1/sales-app/sales-order-return`;

//obtaining the paginated data
export const getSaleReturnBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleReturnBranchURL}/list?party_type=branch_customer&${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleReturnBranch = () =>
  axiosInstance.get(`${saleReturnBranchURL}/list?party_type=branch_customer&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleReturnBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleReturnBranchURL}/list?party_type=branch_customer&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );
// get by id
export const getSaleReturnBranchById = (id) => axiosInstance.get(`${saleReturnBranchURL}/retrieve/${id}`);

// get invoice details
export const getSaleInvoiceDetail = (id) =>
  axiosInstance.get(`api/v1/sales-app/sales-invoice/retrieve-for-sale-return/${id}`);

export const getSaleReturnBranchAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createSaleReturnBranch = (body) => axiosInstance.post(`${saleReturnBranchURL}/create`, body);
//updating function
export const updateSaleReturnBranch = (id, body) => axiosInstance.patch(`${saleReturnBranchURL}/update/${id}`, body);

//approve function
export const approveSaleReturnBranch = (id) => axiosInstance.patch(`${saleReturnBranchURL}/approve/${id}`);

// cancel function
export const cancelSaleReturnBranch = (id) => axiosInstance.patch(`${saleReturnBranchURL}/cancel/${id}`);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleReturnBranchURL}/list?party_type=branch_customer&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
